import SEO from "@/components/SEO";
import PageHero from "@/components/sections/PageHero";
import CTASection from "@/components/sections/CTASection";
import IndustryCard from "@/components/sections/IndustryCard";
import { Reveal } from "@/components/motion/Reveal";
import { Btn } from "@/components/primitives";
import { industries } from "@/content/industries";

export default function Industries() {
  return (
    <>
      <SEO
        title="Digital Growth Systems for Trade Industries | Green Circle Group"
        description="Green Circle Group adapts the service, targeting, customer journey and follow-up to your trade—electricians, plumbers, solar, heating and cooling, builders and landscapers."
        path="/industries"
      />
      <PageHero
        eyebrow="Industries"
        heading="Digital growth systems shaped around your trade."
        copy="A plumber, electrician, solar installer and builder do not sell in the same way. Green Circle Group adapts the service, targeting, customer journey and follow-up process to the type of work the business wants to win."
        breadcrumbs={[
          { label: "Home", to: "/" },
          { label: "Industries", to: "/industries" },
        ]}
      >
        <Btn to="/contact">Book a Free Growth Assessment</Btn>
      </PageHero>

      <section className="bg-soft py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {industries.map((ind, i) => (
              <Reveal key={ind.slug} delay={(i % 3) * 0.06}>
                <IndustryCard industry={ind} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
